import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgCheckmarkBadge = function SvgCheckmarkBadge(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: _jsx("path", {
      fill: props.color || '#222222',
      fillRule: "evenodd",
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm2.787 3.09a.5.5 0 0 1 .168.618l-.045.079-3.5 5a.5.5 0 0 1-.644.155l-.078-.052-2.5-2a.5.5 0 0 1 .55-.83l.074.05 2.084 1.666 3.194-4.563a.5.5 0 0 1 .697-.123Z",
      clipRule: "evenodd"
    })
  }));
};

export default SvgCheckmarkBadge;